<div class="flex flex-row items-stretch justify-center m-auto gap-2">
    <app-button
        [icon]="['fas', 'trash']"
        [type]="ButtonType.ALERT_SECONDARY"
        (onClick)="clearArea()" />
    <app-button
        [icon]="['fas', 'check']"
        [label]="'validateArea' | transloco"
        (onClick)="validateArea()" />
    <app-button
        [label]="'cancel' | transloco"
        [type]="ButtonType.SECONDARY"
        (onClick)="cancelArea()" />
</div>
